<template>
  <div :style="style">
    <div class="upcoming-content">
      <div class="step">
        <h2 class="center-aligned">
          {{ $t('ppwc.p71') }}
        </h2>
        <div class="table">
          <p class="p1">
            {{ $t('ppwc.p8') }}
          </p>
          <p class="p2">
            {{ param.serial_no }}
          </p>
          <van-divider />
          <p class="p1">
            {{ $t('ppwc.p20') }}
          </p>
          <p class="p2">
            {{ param.name }}
          </p>
          <van-divider />
          <p class="p1">
            {{ idType[param.id_type] }}
          </p>
          <p class="p2">
            {{ param.id_num }}
          </p>
          <van-divider />
          <p class="p1">
            {{ $t('ppwc.p28') }}
          </p>
          <p class="p2">
            {{ param.platform }}
          </p>
          <van-divider />
          <p class="p1">
            {{ $t('ppwc.p33') }}
          </p>
          <p class="p2">
            {{ param.birthday }}
          </p>
          <van-divider />
          <p class="p1">
            {{ $t('ppwc.p38') }}
          </p>
          <p class="p2">
            {{ param.preferred }}
          </p>
          <van-divider />
          <p class="p1">
            {{ $t('ppwc.p14') }}
          </p>
          <p class="p2">
            {{ param.email }}
          </p>
          <van-divider />
        </div>

        <div class="buttons">
          <div
            class="confirm"
            @click="confirm"
          >
            <p>{{ $t('ppwc.p12') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      style: {},
      idType : {
        '1': this.$t('ppwc.p24'),
        '2': this.$t('ppwc.p25'),
        '3': this.$t('ppwc.p26')
      }
    }
  },
  mounted() {
    let height = document.documentElement.scrollHeight || document.body.scrollHeight
    let minHeight = height - document.querySelector('.header').offsetHeight - document.querySelector('.slider-tabbar').offsetHeight
    this.style = {
      minHeight: minHeight + 'px'
    }
  },
  created() {
    this.$store.commit('changeTab', 1)
  },
  methods: {
    confirm() {
      this.$router.push({name: 'events'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.upcoming-content {
  padding: 20px 0px 60px 0px;
  font-size: 28px;
  line-height: 26px;
}
.step {
  padding: 0 24px;
  h2 {
    font-size: 40px;
    line-height: 50px;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .table {
    margin: 0px 0px;
    .van-divider {
      margin: 32px 0px;
    }
    .p1 {
      margin: 0px;
      font-size: 32px;
      line-height: 28px;
    }
    .p2 {
      margin: 0px; 
      font-size: 32px;
      line-height: 32px;
      margin-top: 8px;
      font-weight: bold;
      color: #289753;
    }
  }
  .buttons {
    margin-top: 50px;
  }
  .confirm {
    width: 100%;
    height: 70px;
    // margin: 30px auto 0px auto;
    // display: inline-block;
    // margin-left: 40px;
    // background: url('/official_mobile/static/img/events/activate/banner_01.png') no-repeat center center;
    // background-size: 100%;
    background-color: #289753;
    border-radius: 8px;
    cursor: pointer;
    p {
      text-align: center;
      line-height: 70px;
      font-size: 30px;
      color: #fff;
    }
  }
}
</style>
